import { HttpClient, HttpParams } from '@angular/common/http';
import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AddCommentVo } from 'src/app/models/comment';
import { DataHolderVo } from 'src/app/models/DataHolderVo';
import { Feeds } from 'src/app/models/feeds';
import { JobOpeningsVo } from 'src/app/models/jobOpenings';
import { TechQuestionVo } from 'src/app/models/questDeatilVo';
import { CommonService } from 'src/app/service/common.service';
import { MessageService } from 'src/app/service/messageService';

@Component({
  selector: 'app-dashboard-view-two',
  templateUrl: './dashboard-view-two.component.html',
  styleUrls: ['./dashboard-view-two.component.scss']
})
export class DashboardViewTwoComponent implements OnInit,AfterViewInit {
  constructor(
    private http: HttpClient,
    private commonService: CommonService,
    private tostr:MessageService,
    private router:Router
  ) { }

  feeds:Feeds[] = [];
  jobOpenings:JobOpeningsVo[] = [];
  questions:TechQuestionVo[] = [];

  selectedField:Feeds = new Feeds();
  selectedOpenings:JobOpeningsVo = new JobOpeningsVo();
  selectedQuestions:TechQuestionVo = new TechQuestionVo();

  menu:string = "feeds";
  menuViewName = "News";
  imageUrl: any = "https://codingislove.com/wp-content/uploads/2015/12/codinglovenew.png";

  @Input() value = "";

  selectedId:string = "";
  comet:string = "";

  ngOnInit(): void {

    if(this.value != undefined && this.value != ""){
      let splitted = this.value.split(":");
      console.log(splitted);
      this.menu = splitted[0];
      this.selectMenuViewName(this.menu);
      this.selectedId = splitted[1];
     }

      console.log(history.state);
      if(history.state.feeds != undefined && history.state.jobOpenings
        && history.state.questions != undefined){
             this.feeds = history.state.feeds;
             this.jobOpenings = history.state.jobOpenings;
             this.questions = history.state.questions;
             this.loadSelectedData();
      }else{
             this.loadData();
      }
      
     
  }

  

  selectMenuViewName(menuSelected :any ){
    if(menuSelected == "feeds"){
      this.menuViewName = "News";
    } else if(menuSelected == "jobOpenings"){
      this.menuViewName = "Jobs";
    } else if(menuSelected == "questions"){
      this.menuViewName = "Tech Talk";
    }
    this.loadSelectedData();
  }

  ngAfterViewInit(): void {
        document.getElementById(this.selectedId)?.scrollIntoView();
  }

  selectMenu(val:string){
    this.menu = val;
    this.selectMenuViewName(val);
  }


  setSelectedFeed(selectdeItem :any){
    this.selectedField =  selectdeItem;
    this.selectedId = selectdeItem.id;
    let val = "feeds:"+this.selectedId;
    this.reloadPage(val)
  }
  setSelectedTechQuestion(selectdeItem :any){
    this.selectedQuestions =  selectdeItem;
    this.selectedId = selectdeItem.id;
    let val = "questions:"+this.selectedId;
    this.reloadPage(val)
  }

  setSelectedJobOpenings(selectdeItem :any){
    this.selectedOpenings =  selectdeItem;
    this.selectedId = selectdeItem.id;
    let val = "jobOpenings:"+this.selectedId;
    this.reloadPage(val)
  }

  reloadPage(id:any){
    let wholeData = new DataHolderVo();
    wholeData.jobOpenings = this.jobOpenings;
    wholeData.feeds = this.feeds;
    wholeData.questions = this.questions;
    let arr =this.router.url.split("/");
    if(arr[1] == "home"){
          this.router.navigateByUrl("home_detail/"+id,{ state: wholeData })
    }else{
          this.router.navigateByUrl("home/"+id,{ state: wholeData })
    }
  }

  loadSelectedData(){

    if(this.menu == "feeds" && this.feeds != null && this.feeds != undefined && this.feeds.length > 0){ 
      let selectedList = this.feeds.filter((item: any) => item.id == this.selectedId);
      if(selectedList != null && selectedList.length > 0 ){
      this.selectedField = selectedList[0];
      } else {
      this.selectedField = this.feeds[0];
      this.selectedId = this.selectedField.id;
      this.setSelectedFeed(this.selectedField);
      }
    } else if(this.menu== "jobOpenings" && this.jobOpenings != null && this.jobOpenings != undefined && this.jobOpenings.length > 0){
      let selectedList1 = this.jobOpenings.filter((item: any) => item.id == this.selectedId);

      if(selectedList1 != null && selectedList1.length > 0 ){
       this.selectedOpenings = selectedList1[0];
     } else {
       this.selectedOpenings = this.jobOpenings[0];
       this.selectedId = this.selectedOpenings.id;
       this.setSelectedJobOpenings(this.selectedOpenings);
     }
    } else if(this.menu == "questions" && this.questions != null && this.questions != undefined && this.questions.length > 0){
      let selectedList2 = this.questions.filter((item: any) => item.id == this.selectedId);

      if(selectedList2 != null && selectedList2.length > 0 ){
       this.selectedQuestions = selectedList2[0];
     } else {
       this.selectedQuestions = this.questions[0];
       this.selectedId = this.selectedField.id;
       this.setSelectedTechQuestion(this.selectedQuestions);
     } 
    }
     document.getElementById(this.selectedId)?.scrollIntoView();

  }

  loadData(){
    this.getFeedsListCall()
      .subscribe(data => {
       let responce : any = data;
       let listData = responce.body.Items;
       listData.sort(function(a:any,b:any){
        return b.createdDate - a.createdDate
       });
       listData =  listData.filter((item: any) => item.isDeleted != true);

       this.feeds = listData;
          let selectedList = listData.filter((item: any) => item.id == this.selectedId);
          if(selectedList != null && selectedList.length > 0 ){
          this.selectedField = selectedList[0];
        } else {
          this.selectedField = listData[0];
        }
       document.getElementById(this.selectedId)?.scrollIntoView();
      });

      this.getJobOpeningsListCall()
      .subscribe(data => {
       let responce : any = data;
       let listData = responce.body.Items;
       listData.sort(function(a:any,b:any){
        return b.createdDate - a.createdDate
       });
       listData =  listData.filter((item: any) => item.isDeleted != true);

       this.jobOpenings = listData;

       let selectedList = listData.filter((item: any) => item.id == this.selectedId);

       if(selectedList != null && selectedList.length > 0 ){
        this.selectedOpenings = selectedList[0];
      } else {
        this.selectedOpenings = this.jobOpenings[0];
      }
       document.getElementById(this.selectedId)?.scrollIntoView();
      });

      this.gettechQuestionsListCall()
      .subscribe(data => {
       let responce : any = data;
       let listData = responce.body.Items;
       listData.sort(function(a:any,b:any){
        return b.createdDate - a.createdDate
       });
       listData =  listData.filter((item: any) => item.isDeleted != true);

       this.questions = listData;
       let selectedList = listData.filter((item: any) => item.id == this.selectedId);

       if(selectedList != null && selectedList.length > 0 ){
        this.selectedQuestions = selectedList[0];
      } else {
        this.selectedQuestions = this.questions[0];
      }


       document.getElementById(this.selectedId)?.scrollIntoView();
      });
  }

  getFeedsListCall() {
    return this.http.get("https://3898i2a7t4.execute-api.us-west-1.amazonaws.com/default/getFeedList");
  }

  gettechQuestionsListCall() {
    return this.http.get("https://tdnuf7xcgjqaeqfpohjmy3zvei0uhfoy.lambda-url.us-west-1.on.aws/");
  }

  getJobOpeningsListCall() {
    return this.http.get("https://gizcv5lgqmwykti2kbx6py76wq0lildi.lambda-url.us-west-1.on.aws/");
  }

  apply(event: any) {

  }

  isMetadataAvailable(obj: any):boolean {
    if(obj && obj.linkMetaData && obj.linkMetaData.image) {
      return true;
    }
    return false;
  }
  
  isMetadataAvailableWithoutImage(obj: any):boolean {
    if(obj && obj.linkMetaData) {
      return true;
    }
    return false;
  }

  isValidComment(comet: any):boolean {
    if(comet && comet.usrName) {
      return true;
    }
    return false;
  }

  openLinkInNewTab(url:any){
      window.open(url,"_blank");
  }

  getIsLoggedIn():boolean {
    if(localStorage.getItem("isAuthenticated")!= undefined && localStorage.getItem("isAuthenticated") == "true") {
      return true;
    }
    return false;
  }

  validateText(text: string): boolean {
    if (text == undefined || text == null ||
      text == ""  || text.trim().length === 0 ) {
      return false;
    }
    return true;
  }

  addComment() {

    if(this.getIsLoggedIn()){
      let commentVo: AddCommentVo = new AddCommentVo();

      if(!this.validateText(this.comet)){
        this.tostr.error("Invalid Comment");
        return;
      }

      commentVo.id = this.selectedId;
      commentVo.comment = this.comet;
      commentVo.usrName = localStorage.getItem("userName");
      this.addComet(commentVo).subscribe((data: any) => {
        if(this.menu == "questions" && this.questions != null && this.questions != undefined && this.questions.length > 0){
            for (let i = 0; i < this.questions.length; i++) {
              if(data.id == this.questions[i].id){
                this.questions[i] = data;
              }
              
            } 
        }
        this.comet = "";
        let val = "questions:"+this.selectedId;
        this.reloadPage(val)
      })
    } else {
      document.getElementById('loginButtonClick')!.click()

    }

  }


  
  addNewDetail(menu:any) {

    if(this.getIsLoggedIn()){

      if(menu == "feeds"){
        this.router.navigateByUrl("add_feed/-1")
      } else if(menu == "jobOpenings"){
        this.router.navigateByUrl("jobOpening/-1")
      } else if(menu == "questions"){
        this.router.navigateByUrl("techquestion/-1")
      }
     
      
    } else {
      document.getElementById('loginButtonClick')!.click()

    }

  }


  addComet(commentObj: any) {
    return this.http.post("https://4cggyzkenqvz5lijbko4rohnbi0lgffv.lambda-url.us-west-1.on.aws", commentObj);
  }

}
